module.exports = __webpack_public_path__ + "static/img/Mark-Blicavs.63028f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark-Blicavs.jpg
// module id = ABbu
// module chunks = 0